import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";

// 📤 Función para cargar archivo SAP (importación masiva)
export const cargaMasivaSPA = async (formData) => {
  try {
    const { data } = await api.post("/ingreso/SAP/masiva", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al cargar de forma masiva";
  }
};


// 📥 Hook para acceder a endpoints SAP
export const useSAP = () => {
  const { Token } = useUserSuperEmpresa();

  const getSAP = async (params = {}) => {
    try {
      const { data } = await api.get("/sap", {
        params,
        headers: {
          Authorization: `Bearer ${Token}`, 
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener datos SAP";
    }
  };

  const getTotalesPorMesYSucursal = async (params = {}) => { // <- async agregado
    try {
      const { data } = await api.get("/getTotalesPorMesYSucursal", {
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // Enviar token
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener datos SAP";
    }
  };

   const eliminarSapMesyAño = async (mes, anio) => {
  try {
    const { data } = await api.delete(`/sap/mes/${mes}/anio/${anio}`, {
      headers: { Authorization: `Bearer ${Token}` }
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al eliminar los ingresos";
  }
};

 const editarSap = async (id, params = {}) => {
    try {
      const { data } = await api.put(`/sap/${id}`, params, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al editar el usuario";
    }
  };
  return { getSAP, getTotalesPorMesYSucursal, eliminarSapMesyAño, editarSap };
};


// 📊 Hook para manejar estado y obtener toda la data SAP
export const useGetSAP = () => {
  const { Token } = useUserSuperEmpresa();
  const { getSAP, getTotalesPorMesYSucursal } = useSAP();
  const [allSap, setAllSAP] = useState([]);
  const [sapBruto, setSapBruto] = useState([]);
  const [loadingAllSAPBruto, setLoadingAllSAPBruto] = useState(true);
  const [loadingAllSAP, setLoadingAllSAP] = useState(true);
  const [errorAllSAP, setErrorAllSAP] = useState(null);

   const fetchAllSAP = async (params = {}) => {
    setLoadingAllSAP(true);

    try {
      const data = await getSAP(params);

      setAllSAP(data.data);
     
    } catch (err) {
      setErrorAllSAP(
        err.response?.data?.message ||
        "Error al obtener datos SAP"
      );
    } finally {
      setLoadingAllSAP(false);
    }
  };

  useEffect(() => {
    if (Token) {
      fetchAllSAP();
    }
  }, [Token]);

  const fetchSapBruto = async () => {
    setLoadingAllSAPBruto(true);
    try {
      const data = await getTotalesPorMesYSucursal();
      setSapBruto(data.data); 
      
    } catch (err) {
      setErrorAllSAP(
        err.response?.data?.message || "Error al obtener datos SAP"
      );
    } finally {
      setLoadingAllSAPBruto(false);
    }
  };

  useEffect(() => {
    if (Token) fetchSapBruto();
  }, [Token]);

  return {
    allSap,
    sapBruto,
    loadingAllSAPBruto,
    loadingAllSAP,
    errorAllSAP,
    refetchSAP: fetchAllSAP,
    refetchSAPBruto: fetchSapBruto,
  };
};
